/**
* js hp menu
*/
export function jsHpMenuInit() {
    const menuWrapper = document.querySelector('.js-hpmenu-wrapper');
    const menuLinks = document.querySelectorAll('.js-hpmenu-link');
    const menuItems = document.querySelectorAll('.js-hpmenu-item');
    const menuItemDefault = document.querySelector('.js-hpmenu-item--default');

   let noneMenuItemActive = true;

   function activateMenuLink(menuLink) {
       let menuLinkTarget = document.querySelector(menuLink.getAttribute('data-target'));

       menuLinks.forEach(menuLink => {
           menuLink.classList.remove('js-hpmenu-link--active');
       });

       menuItems.forEach(menuItem => {
           menuItem.classList.remove('js-hpmenu-item--active');
       });

       menuLink.classList.add('js-hpmenu-link--active')
       menuLinkTarget.classList.add('js-hpmenu-item--active');
       //site.classList.add('site--backdrop-hp-menu');
   }

   function deactivateAllMenuLinks() {
       menuLinks.forEach(menuLink => {
           menuLink.classList.remove('js-hpmenu-link--active');
       });
       menuItems.forEach(menuItem => {
           menuItem.classList.remove('js-hpmenu-item--active');
       });

       menuItemDefault.classList.add('js-hpmenu-item--active');
       //site.classList.remove('site--backdrop-hp-menu');
   }

   const ACTIVATION_MILLISECONDS = 300;

   let hoveredItemIndex = 0;

   if (menuWrapper && menuLinks && menuItems && menuItemDefault) {
       menuLinks.forEach(menuLink => {
           menuLink.addEventListener('mouseenter', () => {
               hoveredItemIndex++;
               const currentIndex = hoveredItemIndex;

               if (noneMenuItemActive) {
                   activateMenuLink(menuLink);
                   noneMenuItemActive = false;
               } else {
                   setTimeout(() => {
                       if (currentIndex === hoveredItemIndex)
                           activateMenuLink(menuLink);
                   }, ACTIVATION_MILLISECONDS);
               }
           });

           menuLink.addEventListener('mouseleave', () => {
               hoveredItemIndex++;
           });
       });

       menuWrapper.addEventListener('mouseleave', () => {
           hoveredItemIndex++;
           deactivateAllMenuLinks();
           noneMenuItemActive = true;
       });
   }
}